import React from "react"
import { withRouter } from "react-router-dom"
import Base from "./Base"
import InvoiceView from "../../Components/Invoices/InvoiceView"
import { } from "antd"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
class InvoiceVisualizer extends React.Component {

    render() {
if (this.props.login.user_data.estado_usuario ==='INACTIVO'|| this.props.login.user_data.estado_usuario === 'INCOMPLETO'){
    this.props.history.push('/')
}else if (this.props.match.params.id === null || this.props.match.params.id === undefined){
    this.props.history.push('/facturas-emitidas')
}

        return (
            <Base
                title="Visualización de Factura"
                selected="visualizar-factura"

            >
                <InvoiceView invoice_id={this.props.match.params.id} hideButtons={false}/>
            </Base>

        );
}
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InvoiceVisualizer));